import { generateKeyPair as generate } from '../runtime/generate.js';
export async function generateKeyPair(alg, options) {
    return generate(alg, options);
}



// WEBPACK FOOTER //
// ./~/jose/dist/browser/key/generate_key_pair.js